import { render, staticRenderFns } from "./cog_number_sep.vue?vue&type=template&id=2b4f1448&"
import script from "./cog_number_sep.vue?vue&type=script&lang=js&"
export * from "./cog_number_sep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports